import { render, staticRenderFns } from "./BulkDeleteBrandPopup.vue?vue&type=template&id=20b4dec8&scoped=true&"
import script from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeleteBrandPopup.vue?vue&type=style&index=0&id=20b4dec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4dec8",
  null
  
)

export default component.exports